export enum ECERTIFICATE_CONSTANTS {
  defaultCode = 'Неважно',
  insertInput = 'insertText',
}
